import { render, staticRenderFns } from "./VSLMultilingualTextInputRowRenderer.vue?vue&type=template&id=9f5a34b2&scoped=true"
import script from "./VSLMultilingualTextInputRowRenderer.vue?vue&type=script&lang=js"
export * from "./VSLMultilingualTextInputRowRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5a34b2",
  null
  
)

export default component.exports